import React, { useContext } from "react"
import { useCalendarContentStyles } from "Components/Preset/CalendarContent/style"
import { useCalendarContent } from "Components/Preset/CalendarContent/hook"
import { PresetContext, WeekDay } from "Components/Preset/context"
import { PresetPlace } from "Types/place"
import MoveWrap from "../MoveTool/MoveWrap"
import SelectWrap from "../SelectTool/SelectWrap"
import ItemWrap from "./ItemWrap"
import EmptyItem from "../EmptyItem"
import ContentItem from "../ContentItem"
import { getUniqueKey } from "Methods/basic"
export default () => {
    const classes = useCalendarContentStyles()
    const { sidePlaces, weekDays, calendarData } = useContext(PresetContext)
    useCalendarContent()
    return (
        <div className={classes.root}>
            <MoveWrap>
                {
                    sidePlaces.map((place: PresetPlace) => (
                        <SelectWrap key={getUniqueKey()}>
                            <div className={classes.label}>{place.name}</div>
                            {
                                weekDays.map((weekDay: WeekDay) => (
                                    <ItemWrap key={getUniqueKey()}>
                                        {
                                            calendarData[`${weekDay.day}${place.seq_id}`] ? (
                                                <ContentItem
                                                    content={calendarData[`${weekDay.day}${place.seq_id}`]}
                                                    weekDay={weekDay}
                                                    place={place}
                                                />
                                            ) : (
                                                <EmptyItem weekDay={weekDay} place={place}/>
                                            )
                                        }
                                    </ItemWrap>
                                ))
                            }
                        </SelectWrap>
                    ))
                }
            </MoveWrap>
        </div>
    )
}

